import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Typography } from '@material-ui/core'
import builtConnect from '../../../assets/images/illustrations/built_connect.png'
const useStyles = makeStyles((theme) => ({
  commanTitle: {
    textAlign: 'center',
    marginBottom: 50,
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
    },
    '& h4': {
      fontWeight: 800,
      fontSize: 50,
      lineHeight: '60px',
      color: '#1A1A1A',
      marginBottom: 30,
      [theme.breakpoints.down('xs')]: {
        fontSize: 32,
        lineHeight: '43px',
      },
    },
    '& p': {
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '24px',
      color: theme.palette.common.black,
      [theme.breakpoints.down('xs')]: {
        fontSize: 18,
        lineHeight: '22px',
      },
    },
  },
  bottomBanner: {
    '& img': {
      width: '100%',
      height: '100%',
      verticalAlign: 'bottom',
      [theme.breakpoints.down('xs')]: {
        transform: 'scale(1.3)',
        transformOrigin: '150px',
        marginTop: 60,
      },
    },
  },
}))

const Connecting = () => {
  const classes = useStyles()

  return (
    <div>
      <Grid container justifyContent="center">
        <Grid item sm={8} md={5}>
          <div className={classes.commanTitle}>
            <Typography variant="h4">Built to connect</Typography>
            <Typography variant="body1">
              With Conduiit you can be connected with Banks, Production
              Companies, Vendors, Studios, Networks, Payroll Companies and
              users.
            </Typography>
          </div>
        </Grid>
      </Grid>
      <div className={classes.bottomBanner}>
        <img src={builtConnect} alt="" />
      </div>
    </div>
  )
}

export default Connecting
